import { apiClient } from '../../../lib/api/client';
import type {
  CampaignListItem,
  CampaignDetail,
  CampaignFormValues,
  GetCampaignsParams,
  PagedResult,
} from '../types';

export async function getCampaigns(
  params: GetCampaignsParams = {}
): Promise<PagedResult<CampaignListItem>> {
  const { pageNumber = 1, pageSize = 10, status, channelId } = params;

  const searchParams = new URLSearchParams();
  searchParams.set('pageNumber', String(pageNumber));
  searchParams.set('pageSize', String(pageSize));
  if (status !== undefined) searchParams.set('status', String(status));
  if (channelId !== undefined) searchParams.set('channelId', String(channelId));

  const response = await apiClient.get<PagedResult<CampaignListItem>>(
    `/campaigns?${searchParams.toString()}`
  );
  return response.data;
}

export async function getCampaignById(id: string): Promise<CampaignDetail> {
  const response = await apiClient.get<CampaignDetail>(`/campaigns/${id}`);
  return response.data;
}

export async function createCampaign(values: CampaignFormValues): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/campaigns', {
    name: values.name,
    description: values.description ?? null,
    channelId: values.channelId,
    status: values.status,
    startDateUtc: values.startDateUtc ?? null,
    endDateUtc: values.endDateUtc ?? null,
    budget: values.budget ?? null,
    targetedAmountGoal: values.targetedAmountGoal ?? null,
    tags: values.tags ?? [],
  });
  return response.data;
}

export async function updateCampaign(id: string, values: CampaignFormValues): Promise<void> {
  await apiClient.put(`/campaigns/${id}`, {
    name: values.name,
    description: values.description ?? null,
    channelId: values.channelId,
    status: values.status,
    startDateUtc: values.startDateUtc ?? null,
    endDateUtc: values.endDateUtc ?? null,
    budget: values.budget ?? null,
    targetedAmountGoal: values.targetedAmountGoal ?? null,
    tags: values.tags ?? [],
  });
}

export async function deleteCampaign(id: string): Promise<void> {
  await apiClient.delete(`/campaigns/${id}`);
}
